import React, { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import LeafletMap from 'modules/common/components/LeafletMap';
import * as cmsActions from 'modules/settings/cms/action';
import * as cmsConstants from 'modules/settings/cms/constant';
import BplsDashboardChartContainerE2E from './containers/BplsDashboardChartContainerE2E';
// import DashboardMapContainer from './containers/DashboardMapContainer';
import * as actions from './action';
import * as c from './constant';

// Issued - Issued
// For Pick-up - For Pick-up
// For Printing - For Printing
// Waiting for Payment - Waiting for Payment
// For Payment - Pending
// For Assessment of Fees - FOR LICENSE ASSESSMENT
// For Endorsing Offices Assessment - FOR ENDORSING OFFICES ASSESSMENT
// For Evaluation - FOR PERMIT PROCESS
// For Resubmission - FOR RESUBMISSION
// Expired Reference Number - SAME
// Cancelled - SAME

const getStatusList = (data) => [
  {
    label: 'Issued',
    value: _.get(data, 'ISSUED', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Pick-Up',
    value: _.get(data, 'FOR PICK-UP', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Printing',
    value: _.get(data, 'PAID', 0),
    borderClassName: 'paid',
  },
  {
    label: 'Waiting for Payment',
    value: _.get(data, 'WAITING FOR PAYMENT', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Payment Confirmation',
    value: _.get(data, 'FOR PAYMENT CONFIRMATION', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Payment',
    value: _.get(data, 'COMPUTED', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Assessment of Fees',
    value: _.get(data, 'FOR LICENSE ASSESSMENT', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Endorsing Offices Assessment',
    value: _.get(data, 'FOR ENDORSING OFFICES ASSESSMENT', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Evaluation',
    value: _.get(data, 'FOR PERMIT PROCESS', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'Revoked',
    value: _.get(data, 'REVOKED', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Resubmission',
    value: _.get(data, 'FOR RESUBMISSION', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'Expired SOA',
    value: _.get(data, 'EXPIRED SOA', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'Expired Reference Number',
    value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'Cancelled',
    value: _.get(data, 'CANCELLED', 0),
    borderClassName: 'waiting',
  },
];

function TransactionsContainer({
  totalStats,
  getTotalStatsE2E,
  getMapDataE2E,
  mapData,
  getList,
  item,
}) {
  const defaultLat = +_.get(item, 'BPLS_PINNED_LOCATION_LATITUDE', 0);
  const defaultLng = +_.get(item, 'BPLS_PINNED_LOCATION_LONGITUDE', 0);
  const defaultPin = { lat: defaultLat, lng: defaultLng };

  const pins = useMemo(() => {
    if (!mapData || isEmpty(mapData)) return [defaultPin];

    return mapData.map((x) => {
      const businessName = _.get(x, 'business_name', '');
      const pinnedLoc = _.get(x, 'pinned_geolocation', '');
      const [lat, lng] = pinnedLoc.split(',');
      return {
        lat: +lat,
        lng: +lng,
        popup: businessName,
      };
    });
  }, [mapData]);

  const returnNewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_new_per_status');
    return {
      label: 'New',
      total: _.get(totalStats, 'item.total_bpls_new', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  const returnRenewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_renewal_per_status');
    return {
      label: 'Renewal',
      total: _.get(totalStats, 'item.total_bpls_renewal', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  const returnQuarterlyTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_quarterly_per_status');
    return {
      label: 'Quarterly',
      total: _.get(totalStats, 'item.total_bpls_quarterly', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  const returnDelinquentTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_delinquent_per_status');
    return {
      label: 'Delinquent',
      total: _.get(totalStats, 'item.total_bpls_delinquent', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  const returnChangeTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_change_per_status');
    return {
      label: 'Change',
      total: _.get(totalStats, 'item.total_bpls_change', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  const returnRetirementTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_retirement_per_status');
    return {
      label: 'Retirement',
      total: _.get(totalStats, 'item.total_bpls_retirement', 0),
      // photo: ''
      list: getStatusList(data),
    };
  };

  useEffect(() => {
    getTotalStatsE2E();
    getMapDataE2E();
    getList({ type: 'COMPONENTS' });
  }, []);

  return (
    <div className="container-fluid mb-3 pt-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnNewTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnRenewTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnQuarterlyTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnDelinquentTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnChangeTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnRetirementTransactionData()}
            className="mb-3"
          />
        </div>
        <div className="col-8 pr-0">
          {/* todo:  create and replace this with BplsDashboardChartContainerE2EE2E for e2e dashboard component */}
          <BplsDashboardChartContainerE2E />
          {/* <DashboardMapContainer data={mapData} /> */}
          <div
            style={{ height: '800px', width: '100%' }}
            className="mt-5 d-flex flex-column"
          >
            <h3 className="font-weight-bold">Business Location</h3>
            <LeafletMap
              pins={pins}
              zoom={14}
              center={[defaultLat, defaultLng]}
              viewOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStatsE2E: PropTypes.instanceOf(Function).isRequired,
  getMapDataE2E: PropTypes.instanceOf(Function).isRequired,
  mapData: PropTypes.instanceOf(Array).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => {
  const cmsData = _.get(api, `${cmsConstants.GET_SETTINGS}.list`) || [];
  const cmsItem = cmsData[0] || {};
  const parsedItem = JSON.parse(_.get(cmsItem, 'attributes.body') || '{}');

  return {
    totalStats: _.get(api, `${c.GET_TOTAL_STATS_E2E}`) || {},
    mapData: _.get(api, `${c.GET_MAP_DATA_E2E}.list`) || [],
    item: parsedItem,
  };
};

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions, ...cmsActions }),
]);

export default enhance(TransactionsContainer);
